import { convertCentsToDollars } from 'utils/DataTransform/utils/index.js';
import { currencySymbol } from 'utils/currency-symbol';
import {
  transportServiceOption,
  vehicleCategoryOption,
} from 'containers/Pages/Tasks/TripTypes/Layouts/options';

export const getPriceInDollars = (price, currency) => {
  if (price >= 0) {
    const dollars = convertCentsToDollars(price);
    return `${currencySymbol(currency)} ${dollars}`;
  } else {
    return price;
  }
};
const getName = (options, id) => {
  const data = options.find(option => option.id === id);
  if (data) {
    return data.name;
  } else {
    return '-';
  }
};

export const transform = tripTypeList => {
  return tripTypeList.map(tripType => ({
    ...tripType,
    flagFall: getPriceInDollars(tripType.flagFall, tripType.currency),
    srFlagFall: getPriceInDollars(tripType.srFlagFall, tripType.currency),
    srSharePercentOnCost: tripType.srSharePercentOnCost,
    costPerKM: getPriceInDollars(tripType.costPerKM, tripType.currency),
    serviceType: getName(
      transportServiceOption,
      tripType.serviceType,
      tripType.currency,
    ),
    costPerMin: getPriceInDollars(tripType.costPerMin, tripType.currency),
    vehicleCategory: getName(
      vehicleCategoryOption,
      tripType.vehicleCategory,
      tripType.currency,
    ),
    vehicleType: tripType.vehicleType,
    currencySymbol: currencySymbol(tripType.currency),
  }));
};
